// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}
.company-policies-container {
  width: 100%;
  height: 100%;
  border: 1px solid rgb(228 227 227);
  border-radius: 10px;
  /* display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
}
.company-container-2 {
  border: 1px solid rgb(228 227 227);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 94%;
  height: 92%;
  padding: 10px;
  margin: 20px;
}
.Uper-heading-company-policy {
  width: 100%;
  border-bottom: 1px solid #dcd4d4;
}
.Uper-heading-company-policy h2 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
}
.company-policy-header input {
  width: 100%;
  padding: 8px;
  margin-top: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.company-policy-select {
  width: 100%;
}
.company-policy-sub-container {
  /* border: 1px solid rgb(213, 213, 213);
  border-radius: 10px; */
  width: 90%;
  height: 20%;
  display: flex;
  gap: 10px;
}
.company-policy-header {
  width: 100%;
  margin: 7px;
}

.heading-company-policy {
  width: 100%;
  display: flex;
  /* justify-content: center; */
  /* align-items: center; */
  margin-bottom: 10px;
  /* border-bottom: 1px solid black; */
  margin-top: -68px;
  gap: 300px;
}
.policy-botton-container {
  width: 89%;
  text-align: end;
  margin-top: 10px;
}
.policy-button {
  width: 10%;
}

.company-policy-title {
  font-size: 14px;
}

/* policy table */
.policy-table-container {
  margin: 10px;
  margin-top: 10px;
}

.add-policy-button-container {
  /* border: 1px solid black; */
  text-align: end;
  width: 95%;
  margin: 10px;
}

.company-policy-back-button-container {
  border: 1px solid black;
  width: 100%;
  margin-top: 0px;
}

.heading-company-policy button {
  font-size: larger;
}

.policy-table-container {
  max-height: 350px; /* set height limit */
  overflow-y: auto; /* vertical scroll */
  overflow-x: auto; /* horizontal scroll if table is wide */
  border: 1px solid #ddd; /* optional for better look */
  border-radius: 10px;
}
/* .policy-table-container::-webkit-scrollbar {
  display: none;
} */
.company-policy-table {
  width: 100%;
  border-collapse: collapse;
}

.company-policy-table th,
.company-policy-table td {
  padding: 8px;
  text-align: center;
  border: 1px solid #ddd;
}
.company-policy-table th {
  background-color: #deecdd;
  position: sticky;
  top: 0;
  font-size: 12px;
  font-weight: bold;
}
.company-policy-table td {
  font-weight: 600;
  font-size: 11px;
}

.company-policy-table tbody tr:nth-child(odd) {
  /* border: 1px solid #000; */
  background-color: #c6bcbc37;
}
.company-policy-input{
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/AdminPanel/CompanyPolicies/CompanyPolicies.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB;;;wBAGsB;AACxB;AACA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,aAAa;EACb,YAAY;AACd;AACA;EACE,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE;wBACsB;EACtB,UAAU;EACV,WAAW;EACX,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;EACpC,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,UAAU;EACV,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB,EAAE,qBAAqB;EACxC,gBAAgB,EAAE,oBAAoB;EACtC,gBAAgB,EAAE,uCAAuC;EACzD,sBAAsB,EAAE,6BAA6B;EACrD,mBAAmB;AACrB;AACA;;GAEG;AACH;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;IACI,WAAW;AACf","sourcesContent":["* {\n  margin: 0px;\n  padding: 0px;\n  box-sizing: border-box;\n}\n.company-policies-container {\n  width: 100%;\n  height: 100%;\n  border: 1px solid rgb(228 227 227);\n  border-radius: 10px;\n  /* display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center; */\n}\n.company-container-2 {\n  border: 1px solid rgb(228 227 227);\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 94%;\n  height: 92%;\n  padding: 10px;\n  margin: 20px;\n}\n.Uper-heading-company-policy {\n  width: 100%;\n  border-bottom: 1px solid #dcd4d4;\n}\n.Uper-heading-company-policy h2 {\n  text-align: center;\n  margin-bottom: 20px;\n  font-size: 24px;\n  font-weight: bold;\n}\n.company-policy-header input {\n  width: 100%;\n  padding: 8px;\n  margin-top: 4px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.company-policy-select {\n  width: 100%;\n}\n.company-policy-sub-container {\n  /* border: 1px solid rgb(213, 213, 213);\n  border-radius: 10px; */\n  width: 90%;\n  height: 20%;\n  display: flex;\n  gap: 10px;\n}\n.company-policy-header {\n  width: 100%;\n  margin: 7px;\n}\n\n.heading-company-policy {\n  width: 100%;\n  display: flex;\n  /* justify-content: center; */\n  /* align-items: center; */\n  margin-bottom: 10px;\n  /* border-bottom: 1px solid black; */\n  margin-top: -68px;\n  gap: 300px;\n}\n.policy-botton-container {\n  width: 89%;\n  text-align: end;\n  margin-top: 10px;\n}\n.policy-button {\n  width: 10%;\n}\n\n.company-policy-title {\n  font-size: 14px;\n}\n\n/* policy table */\n.policy-table-container {\n  margin: 10px;\n  margin-top: 10px;\n}\n\n.add-policy-button-container {\n  /* border: 1px solid black; */\n  text-align: end;\n  width: 95%;\n  margin: 10px;\n}\n\n.company-policy-back-button-container {\n  border: 1px solid black;\n  width: 100%;\n  margin-top: 0px;\n}\n\n.heading-company-policy button {\n  font-size: larger;\n}\n\n.policy-table-container {\n  max-height: 350px; /* set height limit */\n  overflow-y: auto; /* vertical scroll */\n  overflow-x: auto; /* horizontal scroll if table is wide */\n  border: 1px solid #ddd; /* optional for better look */\n  border-radius: 10px;\n}\n/* .policy-table-container::-webkit-scrollbar {\n  display: none;\n} */\n.company-policy-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.company-policy-table th,\n.company-policy-table td {\n  padding: 8px;\n  text-align: center;\n  border: 1px solid #ddd;\n}\n.company-policy-table th {\n  background-color: #deecdd;\n  position: sticky;\n  top: 0;\n  font-size: 12px;\n  font-weight: bold;\n}\n.company-policy-table td {\n  font-weight: 600;\n  font-size: 11px;\n}\n\n.company-policy-table tbody tr:nth-child(odd) {\n  /* border: 1px solid #000; */\n  background-color: #c6bcbc37;\n}\n.company-policy-input{\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
